<template>
  <Datatable
    entity="customer"
    :parameters="{branch: $route.query.branch}"
    :onRowClick="displayCustomer"
    :rowActions="[{text: 'datatable.display', method: displayCustomer}]">
  </Datatable>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";

  export default {
    name: "Customers",

    components: { Datatable },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "customers.title";
      this.$store.state.pageIcon = "/icon/user.svg";
    },

    methods: {
      displayCustomer(row) {
        this.$router.push(this.$router.buildContext("/customer", {id: row.id}));
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>